import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './Footer.types';
import { Theme } from '../Modal.types';
import { css } from '@styled-system/css';

export default styled.div<StyledProps, Theme>`
  ${space}
  ${css({
    display: 'flex',
    marginTop: 'auto',
  })}
`;
